var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "go-page-header-type2" }, [
        _vm.routeName === "MyBriefing-All"
          ? _c("div", { staticClass: "go-page-title" }, [
              _vm._v(_vm._s(_vm.$t("briefing.myAgents"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.routeName === "SocialBriefing-All"
          ? _c("div", { staticClass: "go-page-title" }, [
              _vm._v(_vm._s(_vm.$t("briefing.socialAgents"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.routeName === "CompanyBriefing-All"
          ? _c("div", { staticClass: "go-page-title" }, [
              _vm._v(_vm._s(_vm.$t("briefing.companyAgents"))),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.getRecommendationPages &&
      _vm.getRecommendationPages.length > 0 &&
      _vm.routeName === "MyBriefing-All"
        ? _c(
            "div",
            [
              _c("briefing-card-featured", {
                attrs: {
                  briefingPages: _vm.getRecommendationPages,
                  swiperName: _vm.swiperMyAgent,
                },
                on: {
                  select: _vm.handleSelect,
                  updateSubscribe: _vm.handleSubscribe,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getFeaturedPages &&
      _vm.getFeaturedPages.length > 0 &&
      _vm.routeName === "SocialBriefing-All"
        ? _c(
            "div",
            [
              _c("briefing-card-featured", {
                attrs: {
                  briefingPages: _vm.getFeaturedPages,
                  swiperName: _vm.swiperSocialAgent,
                },
                on: {
                  select: _vm.handleSelect,
                  updateSubscribe: _vm.handleSubscribe,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getFeaturedCompanies &&
      _vm.getFeaturedCompanies.length > 0 &&
      _vm.routeName === "CompanyBriefing-All"
        ? _c(
            "div",
            [
              _c("briefing-card-featured-company", {
                attrs: { resourceItems: _vm.getFeaturedCompanies },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "go-agent-card-wrap" }, [
        _c(
          "div",
          { staticClass: "go-widget-card" },
          [
            this.$route.name !== "SocialUser"
              ? _c("div", { staticClass: "go-widget-header" }, [
                  _c("div", { staticClass: "go-elements" }, [
                    _c("div", { staticClass: "go-widget-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("briefing.total")) +
                          " "
                      ),
                      _c("small", [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.isSearchMode
                                ? _vm.searchResults.length
                                : _vm.totalCard
                            ) +
                            ")"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.briefingPages.length > 0 &&
                    _vm.isShowEditButton &&
                    _vm.routeName === "MyBriefing-All"
                      ? _c("div", { staticClass: "go-elements" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-default go-btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.isEditMode = !_vm.isEditMode
                                },
                              },
                            },
                            [
                              _c("i", {
                                class: [
                                  "go-icon-18",
                                  _vm.isEditMode
                                    ? "go-icon-close"
                                    : "go-icon-check",
                                ],
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.isEditMode
                                      ? _vm.$t("briefing.label.edit-cancel")
                                      : _vm.$t("briefing.label.edit-selected")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  this.$route.name !== "CompanyBriefing-All"
                    ? _c("div", { staticClass: "go-form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.keyword,
                              expression: "keyword",
                            },
                          ],
                          staticClass: "go-form-control",
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("briefing.search"),
                          },
                          domProps: { value: _vm.keyword },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearch.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.keyword = $event.target.value
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.loading ? _c("list-loading") : _vm._e(),
            _vm._v(" "),
            _vm.isNoData && _vm.isSearchMode
              ? _c("div", { staticClass: "go-empty" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", { staticClass: "go-info-lead" }, [
                    _vm._v(_vm._s(_vm.$t("briefing.noResults"))),
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "go-info-text",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("briefing.searchNoResultsText")),
                    },
                  }),
                ])
              : _c("div", { staticClass: "go-list-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "go-card-main-grid" },
                    [
                      _vm.routeName === "MyBriefing-All" && !_vm.isSearchMode
                        ? _c(
                            "div",
                            {
                              staticClass: "go-list-item",
                              attrs: {
                                "data-template": "card-create",
                                "data-size": "2x1",
                              },
                            },
                            [
                              _c("div", { staticClass: "go-card-main" }, [
                                _c("div", { staticClass: "go-card-body" }, [
                                  _c("div", { staticClass: "go-empty" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "go-icon-wrap",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOpenPopupAddBriefingForNewBriefing(
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [_vm._m(1)]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "go-info-lead" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "briefing.createNewMyAgentText1"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "go-info-text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "briefing.createNewMyAgentText2"
                                          )
                                        ),
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm.routeName === "SocialBriefing-All" &&
                          !_vm.isSearchMode
                        ? _c(
                            "div",
                            {
                              staticClass: "go-list-item",
                              attrs: {
                                "data-template": "card-create",
                                "data-size": "2x1",
                              },
                            },
                            [
                              _c("div", { staticClass: "go-card-main" }, [
                                _c("div", { staticClass: "go-card-body" }, [
                                  _c("div", { staticClass: "go-empty" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "go-icon-wrap",
                                        on: {
                                          click: function ($event) {
                                            _vm.isOpenAddSocial = true
                                          },
                                        },
                                      },
                                      [_vm._m(2)]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "go-info-lead" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "briefing.createNewMySocialAgentText1"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "go-info-text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "briefing.createNewMySocialAgentText2"
                                          )
                                        ),
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm.routeName === "CompanyBriefing-All" &&
                          !_vm.isSearchMode
                        ? _c(
                            "div",
                            {
                              staticClass: "go-list-item",
                              attrs: {
                                "data-size": "2x1",
                                "data-template": "card-create",
                              },
                            },
                            [
                              _c("div", { staticClass: "go-card-main" }, [
                                _c("div", { staticClass: "go-card-body" }, [
                                  _c("div", { staticClass: "go-empty" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "go-icon-wrap",
                                        on: {
                                          click: function ($event) {
                                            _vm.isOpenAddCompany = true
                                          },
                                        },
                                      },
                                      [_vm._m(3)]
                                    ),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "go-info-text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "briefing.createNewCompanyAgentText"
                                          )
                                        ),
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.routeName === "CompanyBriefing-All"
                        ? _vm._l(
                            _vm.displayBriefingPages,
                            function (item, index) {
                              return _c("company-briefing-agent-card", {
                                key:
                                  (item.bpId &&
                                    item.bpId.concat("_" + index)) ||
                                  (item.other_info.requestId &&
                                    item.other_info.requestId.concat(
                                      "_" + index
                                    )) ||
                                  new Date()
                                    .getTime()
                                    .toString()
                                    .concat("_" + index),
                                attrs: { "form-model": item },
                                on: { "view-detail-report": _vm.viewDetail },
                              })
                            }
                          )
                        : _vm._l(
                            _vm.displayBriefingPages,
                            function (item, index) {
                              return _c("briefing-card", {
                                key: index,
                                attrs: {
                                  "form-model": item,
                                  "is-edit-mode": _vm.isEditMode,
                                  "hide-setting-mode": _vm.hideSettingMode,
                                  routerName: _vm.routeName,
                                  idSwitch: _vm.customSwitch + index,
                                },
                                on: {
                                  "select-user-social": _vm.onSelectUserSocial,
                                  select: function ($event) {
                                    return _vm.select(item)
                                  },
                                  "toggle-subscribe": function ($event) {
                                    return _vm.toggleSubscribed(
                                      item,
                                      index,
                                      _vm.routeName
                                    )
                                  },
                                  handleDeleteBriefings:
                                    _vm.handleDeleteBriefings,
                                },
                              })
                            }
                          ),
                    ],
                    2
                  ),
                ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("add-social-agent", {
        attrs: { "open-modal": _vm.isOpenAddSocial },
        on: {
          close: _vm.handleCloseAddSocial,
          toggleSubscribed: _vm.handleToggleSubscribed,
        },
      }),
      _vm._v(" "),
      _c("add-company-agent", {
        attrs: { "open-modal": _vm.isOpenAddCompany },
        on: {
          close: _vm.handleCloseAddCompany,
          "view-detail-report": _vm.viewDetail,
        },
      }),
      _vm._v(" "),
      _c("popup-select-type-reference", {
        attrs: { open: _vm.openSelectTypeReference },
        on: {
          close: function ($event) {
            _vm.openSelectTypeReference = false
          },
          "select-reference-type":
            _vm.handleOpenPopupAddReferenceBySelectedReferenceTab,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-72 go-icon-search" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("i", { staticClass: "go-icon-72 go-icon-square-rounded-plus-filled" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("i", { staticClass: "go-icon-72 go-icon-square-rounded-plus-filled" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("i", { staticClass: "go-icon-72 go-icon-square-rounded-plus-filled" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }